import { observer } from 'mobx-react';

import Comments from 'components/UI/ChatBox/Comments';
import store from 'stores/RootStore';
import { AnimationPanelViews } from 'types/AnimationPanelViews';

import Drawer from '../Drawer';

function CommentsDrawer() {
  const store_animation = store.animation;
  const store_user = store.user;
  const commentsManager = store_animation?.comments;

  const hasNewComments =
    commentsManager && commentsManager.newCommentsCount > 0;
  let commentsTitle = 'Comments';
  if (hasNewComments) {
    commentsTitle += ` (${commentsManager.newCommentsCount})`;
  }

  const handleClick = () => {
    void commentsManager?.updateViewHistory();
  };

  return (
    <div onClick={handleClick}>
      <Drawer
        label={commentsTitle}
        panelName={AnimationPanelViews.COMMENTS}
        showUnreadIndicator={hasNewComments}
      >
        {store_animation && (
          <Comments
            parentDoc={store_animation}
            user={store_user}
            variant="panel"
          />
        )}
      </Drawer>
    </div>
  );
}

export default observer(CommentsDrawer);
